/**
 * Devuelve la función para mergear el view.dictionary en los campos tipo "properties": "$LIN"
 * /!\ Esta función modifica el view original /!\
 *
 * @param {object} view el view que tiene un campo view.dictionary
 * @param {object} [options]
 * @param {string} options.name
 * @param {boolean} options.forceMaskNumber
 * @return {Function} el mapper
 */

export function mapDictionaryFactory(view) {
  if (!view?.dictionary) {
    return p => p;
  }

  return property => {
    // 04/2023 Potenciamos el dictionary no sólo para properties
    // cargamos los dictionarios del view (ej. los "$LIN"):
    if (typeof property?.properties === 'string') {
      property.properties = get(property.properties);
    }

    // Select
    // 04/2023 Potenciamos el dictionary no sólo para properties: options del select
    if (typeof property?.metadata?.options === 'string') {
      property.metadata.options = get(property.metadata.options);
    }

    return property;
  };

  function get(key) {
    if (!view.dictionary[key]) {
      throw new Error(`mapDictionaryFactory. dictionary "${key}" missing.`);
    }

    return view.dictionary[key];
  }
}
